import _extends from "@babel/runtime/helpers/extends";
import React, { createContext, useContext, useMemo, useState } from 'react';
import Button from '@atlaskit/button';
import ModalDialog, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
const ShowNoticeContext = /*#__PURE__*/createContext(undefined);
export const useShowNotice = () => {
  const noticeApi = useContext(ShowNoticeContext);
  if (!noticeApi) {
    throw Error('Hook must be used in a NoticeProvider');
  }
  return noticeApi;
};
export const NoticeProvider = ({
  children
}) => {
  const [notice, setNotice] = useState();
  const onCloseHandler = () => {
    setNotice(undefined);
    if (notice && notice.onCloseHandler) {
      notice.onCloseHandler();
    }
  };
  const onConfirmHandler = () => {
    setNotice(undefined);
    if (notice && notice.onConfirmHandler) {
      notice.onConfirmHandler();
    }
  };
  const noticeApi = useMemo(() => ({
    showNotice: props => {
      setNotice(props);
    }
  }), []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ShowNoticeContext.Provider, {
    value: noticeApi
  }, children), notice && /*#__PURE__*/React.createElement(Notice, _extends({}, notice, {
    onCloseHandler: onCloseHandler,
    onConfirmHandler: onConfirmHandler
  })));
};
export const Notice = ({
  appearance,
  title,
  body,
  closeText,
  onCloseHandler,
  confirmText,
  onConfirmHandler
}) => {
  const actions = [];
  const primaryButtonAppearance = appearance || 'primary';
  if (confirmText && onConfirmHandler) {
    actions.push({
      key: 'pf-notice-secondary-button',
      appearance: 'subtle',
      onClick: onCloseHandler,
      text: closeText
    });
    actions.push({
      key: 'pf-notice-primary-button',
      appearance: primaryButtonAppearance,
      onClick: onConfirmHandler,
      text: confirmText,
      testId: 'show-notice-confirm-btn'
    });
  } else {
    actions.push({
      key: 'pf-notice-primary-button',
      appearance: primaryButtonAppearance,
      onClick: onCloseHandler,
      text: closeText,
      testId: 'show-notice-close-btn'
    });
  }
  return /*#__PURE__*/React.createElement(ModalDialog, {
    shouldCloseOnOverlayClick: false,
    onClose: onCloseHandler,
    testId: "show-notice-dialog"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, {
    appearance: appearance
  }, title)), /*#__PURE__*/React.createElement(ModalBody, null, body), /*#__PURE__*/React.createElement(ModalFooter, null, actions.map(({
    key,
    text,
    ...props
  }) => /*#__PURE__*/React.createElement(Button, _extends({
    key: key
  }, props), text))));
};